<script>
import { mapGetters } from "vuex";
export default {
  props: ["close", "title"],
  data() {
    return {
      id: this.$route.params.id ? this.$route.params.id : null,
    };
  },
  computed: {
    ...mapGetters({
      autoCue: "scripts/autoCue",
      currentActivity: "scripts/activeWorkout",
    }),
    coloursOptions() {
      return this.$store.getters[`${this.currentType}/coloursOptions`];
    },
    activeColour() {
      return this.coloursOptions && this.currentActivityFull.colour
        ? this.coloursOptions.find(
            (option) => option.id == this.currentActivityFull.colour
          )
        : {
            value: "#469a2e",
          };
    },
    currentActivityFull() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },

    currentType() {
      const url = this.$route.path.split("/")[1];
      if (url && url != "todo") {
        if (this.$route) {
          if (url == "update-warmup" || this.$route.path == "/create-warmup") {
            return "warmups";
          } else if (
            url == "update-stretch-flow" ||
            this.$route.path == "/create-stretch-flow"
          ) {
            return "stretchflows";
          }
        }
        return "workouts";
      }
      return "commons";
    },
    textColor() {
      var brightness = 0;
      if (this.activeColour) {
        var hexcolor = this.activeColour.value.replace("#", "");
        var r = parseInt(hexcolor.substr(0, 2), 16);
        var g = parseInt(hexcolor.substr(2, 2), 16);
        var b = parseInt(hexcolor.substr(4, 2), 16);
        brightness = (r * 299 + g * 587 + b * 114) / 1000;
      }
      return brightness > 125 ? "black" : "white";
    },

    autocue: {
      set(value) {
        this.$store.dispatch(`scripts/setAutoCue`, value);
      },
      get() {
        return this.autoCue;
      },
    },
  },
  methods: {
    /* View in fullscreen */
    openFullscreen() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },

    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },

    openAutoCue() {
      const activityType = this.currentActivityFull.type == 'stretch_flow' ? 'stretch-flow' : this.currentActivityFull.type
      this.$router.push(`/auto-cue/${activityType}/${this.currentActivity}`);
      this.openFullscreen();
    },
    printPreview() {
      const activityType = this.currentActivityFull.type == 'stretch_flow' ? 'stretch-flow' : this.currentActivityFull.type
      window.open(`#/printscript/${activityType}/${this.currentActivityFull.id}`, "_blank");
    },
  },
};
</script>

<style lang="scss">
h5.title {
  font-family: "Times New Roman", Times, serif;
  font-size: 2rem;
  font-weight: 400;
}
.ctrl-buttons {
  float: right;
}
.ctrl-buttons .btn {
  margin-right: 1rem;
  text-transform: uppercase;
  color: #3f9698;
}
.modal-header-wrap {
  padding: 15px;
}
.toggle-box {
  display: inline-block;
}
.toggle-box label {
  margin: 0;
}
.toggle-box .v-switch-label {
  margin: 0;
  color: #000 !important;
}
</style>

<template>
  <div
    class="w-100 modal-header-wrap"
    :style="{ background: activeColour ? activeColour.value : '' }"
  >
    <div class="row align-items-center">
      <h5 class="col-md-4 title mb-0" :style="{ color: textColor }">
        {{ title }}
      </h5>
      <div class="col-md-8 ctrl-container">
        <button type="button" class="close" aria-label="Close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="ctrl-buttons d-flex align-items-center">
          <div class="px-3 py-2 toggle-box">
            <span class="pr-1" :style="{ color: textColor }">Edit mode</span>
            <toggle-button
              v-model="autocue"
              color="#82C7EB"
              :sync="true"
              :labels="true"
            />
            <!-- <span class="pl-1">Auto cue mode</span> -->
          </div>
          <b-button
            variant="light"
            size="sm"
            class="print-preview btn px-3 py-2"
            @click="printPreview"
          >
            <b-icon icon="printer"></b-icon>&nbsp;Print Preview
          </b-button>
          <b-button
            variant="light"
            size="sm"
            class="auto-cure btn px-3 py-2"
            @click="openAutoCue()"
          >
            <b-icon icon="file-slides"></b-icon>&nbsp;Auto Cue
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>